import { createApi } from "@/api/ApiFactory";
import { config } from "@/config/config";

const TorApi = createApi(config.TOR_API_URL);

export default TorApi;
